import ApiService from './ApiService';
import { UserDetails } from '../../src/infrastructure/models';

export const fetchMyProfile = async (signal?: AbortSignal): Promise<UserDetails> => {
    const response = await ApiService.get<UserDetails>({ url: 'User/myprofile', signal });
    return response;
};
